"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const i18n = require("i18n");
const InvalidToken = () => (React.createElement("div", null,
    React.createElement("h4", { className: 'title vf-text-primary' }, i18n.get('REGISTER_EXPIRED_LINK')),
    React.createElement("h4", { className: 'vf-text-gray-dark' }, i18n.get('REGISTER_EXPIRED_LINK_DESCRIPTION'))));
exports.default = InvalidToken;
